import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ipm-license-wav-stems',
  templateUrl: './license-wav-stems.component.html',
  styleUrls: ['./license-wav-stems.component.scss']
})
export class LicenseWavStemsComponent implements OnInit, OnChanges {
  @Input() CurrentLicenseData: any;
  currentLicense:any = '';
  currentData:any = '';
  currentDate:any = new Date();
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['CurrentLicenseData']) {
        this.currentData = this.CurrentLicenseData;
        let priceArray: any = this.currentData?.currentBeatData?.prices;
        let found =  priceArray.find((item: any) => item.licence === this.currentData?.cartData?.beat_price?.licence?._id)
        if (found) {
          this.currentLicense = found;
        }
      }
  }

}
